export const PUBLIC_IMAGES_BUCKET_NAME = 'public-images'
